import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const informesApi = createApi({
  reducerPath: "informesApi",
  baseQuery: baseQuery(`${API_SERVER}/informes`),
  tagTypes: [],
  endpoints: (builder) => ({
    getTasaNegociacionConcreta: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro }) =>
        `/procesos/tasaNegociacionConcreta/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}`,
    }),
    getCapacidadPorCartera: builder.query({
      query: ({ id }) => `/procesos/capacidadPorCartera/${id}`,
    }),
    getTasaCrecimientoCliente: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro }) =>
        `/clientes/tasaCrecimientoCliente/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}`,
    }),
    getTasaClientesPerdidos: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro }) =>
        `/clientes/tasaClientesPerdidos/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}`,
    }),
    getTasaRetencionClientes: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro }) =>
        `/clientes/tasaRetencionClientes/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}`,
    }),
    getNLeads: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro }) =>
        `/clientes/nLeads/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}`,
    }),
    getRecaudacionesMensualesSucursales: builder.query({
      query: ({ fechaInicio, fechaTermino }) =>
        `/recaudacionesMensualesSucursales/?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}`,
    }),
    obtenerRecaudacionesYFacturasTotales: builder.query({
      query: ({ rut, fechaTermino, fechaInicio, fechaFin, sucursales }) => {
        // Preparar parámetros para enviar
        const params = {
          fechaActual: fechaTermino,
        };

        // Solo agregar parámetros si existen
        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }
        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        if (sucursales && sucursales.length > 0) {
          // Convertir array a string para envío por query params
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/obtenerRecaudacionesYFacturasTotales/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getKpiEficienciaCobranza: builder.query({
      query: ({ fechaInicio, fechaFin, sucursales }) => {
        const params = {
          fechaInicio,
          fechaFin,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: "/kpis/eficienciaCobranza",
          method: "GET",
          params,
        };
      },
    }),
    getKpiCumplimientoTareas: builder.query({
      query: ({ fechaInicio, fechaFin, sucursales }) => {
        const params = {
          fechaInicio,
          fechaFin,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: "/kpis/cumplimientoTareas",
          method: "GET",
          params,
        };
      },
    }),
    getKpiMorosidad: builder.query({
      query: ({ fechaInicio, fechaFin, sucursales }) => {
        const params = {
          fechaInicio,
          fechaFin,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: "/kpis/morosidad",
          method: "GET",
          params,
        };
      },
    }),
    getRecaudacionesMensualesGav: builder.query({
      query: ({ fechaFacturacion }) =>
        `/recaudacionesMensualesGav/?fechaFacturacion=${fechaFacturacion}`,
    }),
    getInformeLiquidacion: builder.query({
      query: ({ fechaFacturacion, sucursal }) =>
        `/generarInformeLiquidacion/?fechaFacturacion=${fechaFacturacion}&filtro=${sucursal}`,
    }),
    getInformacionFacturacionAnio: builder.query({
      query: ({ rut, sucursales, anio }) => {
        const params = {};

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (anio) {
          params.anio = anio;
        }

        return {
          url: `/informacionFacturacionRecaudacionPendienteAnio/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getInformacionEstadisticasFacturacion: builder.query({
      query: ({ rut, sucursales, anio }) => {
        const params = {};

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (anio) {
          params.anio = anio;
        }

        return {
          url: `/informacionEstadisticasFacturacion/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getInformacionfacturacionPorSucursales: builder.query({
      query: ({ rut, sucursales, anio }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (anio) {
          params.anio = anio;
        }

        return {
          url: `/informacionfacturacionPorSucursales`,
          method: "GET",
          params,
        };
      },
    }),
    getInformacionfacturacionPorSucursalesConFecha: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = {
          rut,
          fechaInicio,
          fechaFin,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/informacionfacturacionPorSucursalesConFecha`,
          method: "GET",
          params,
        };
      },
    }),
    getInformacionCrecimientoClientes: builder.query({
      query: ({ rut, sucursales, anio }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (anio) {
          params.anio = anio;
        }

        return {
          url: `/informacionCrecimientoClientes`,
          method: "GET",
          params,
        };
      },
    }),
    getInformacionRecuentoTareas: builder.query({
      query: ({ fechaInicio, fechaFin, sucursales, rut }) => {
        const params = {};

        // Solo agregar parámetros si existen
        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }
        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }
        return {
          url: `/informacionRecuentoTareas/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getDetalleFacturasMensuales: builder.query({
      query: ({ fechaInicio, fechaTermino, sucursales, rut }) => {
        const params = {
          fechaInicio,
          fechaTermino,
          rut,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/detalleFacturasMensuales/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    getDetalleComisionesTarea: builder.query({
      query: (idTarea) => {
        return {
          url: `/detalleComisionesTarea/${idTarea}`,
          method: "GET",
        };
      },
    }),
    getDetalleFacturasTarea: builder.query({
      query: (idTarea) => `/detalleFacturasTarea/${idTarea}`,
    }),
    getDetalleFacturasTareasGeneral: builder.query({
      query: (rutEmpleado) => `/detalleFacturasTareasGeneral/${rutEmpleado}`,
    }),
    getDetalleRecaudacionFacturas: builder.query({
      query: ({
        tipoFactura,
        accion,
        fechaInicio,
        fechaTermino,
        sucursales,
        rut,
      }) => {
        const params = {
          fechaInicio,
          fechaTermino,
          rut,
        };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }
        return {
          url: `/detalleRecaudacionFacturas/${rut}/${tipoFactura}/${accion}`,
          method: "GET",
          params: params,
        };
      },
    }),
    getFacturasPorDia: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro, refCliente }) =>
        `/clientes/facturasPorDia/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}&refCliente=${refCliente}`,
    }),
    getCobrosPorMes: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro, refCliente }) =>
        `/cobrosPorMes/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}&refCliente=${refCliente}`,
    }),
    getTodosCobrosPorMes: builder.query({
      query: ({
        fechaInicio,
        fechaTermino,
        filtro,
        refCliente,
        sucursales,
      }) => {
        const sucursalesQuery = sucursales
          .map((sucursal) => `sucursales=${sucursal.refSucursal}`)
          .join("&");
        return `/todosCobrosPorMes?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}&refCliente=${refCliente}&${sucursalesQuery}`;
      },
    }),
    getCobrosPendientesPorMes: builder.query({
      query: ({ id, fechaInicio, fechaTermino, filtro, refCliente }) =>
        `/cobrosPendientesPorMes/${id}?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}&refCliente=${refCliente}`,
    }),
    getCobrosTotalesPendientesPorMes: builder.query({
      query: ({
        fechaInicio,
        fechaTermino,
        filtro,
        refCliente,
        sucursales,
      }) => {
        const sucursalesQuery = sucursales
          .map((sucursal) => `sucursales=${sucursal.refSucursal}`)
          .join("&");
        return `/cobrosTotalesPendientesPorMes?fechaInicio=${fechaInicio}&fechaTermino=${fechaTermino}&filtro=${filtro}&refCliente=${refCliente}&${sucursalesQuery}`;
      },
    }),
    getPagosPromedioClientes: builder.query({
      query() {
        return {
          url: `/clientes/promedioFacturas`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetTasaNegociacionConcretaQuery,
  useGetCapacidadPorCarteraQuery,
  useGetTasaCrecimientoClienteQuery,
  useGetTasaClientesPerdidosQuery,
  useGetTasaRetencionClientesQuery,
  useGetNLeadsQuery,
  useGetFacturasPorDiaQuery,
  useGetPagosPromedioClientesQuery,
  useGetCobrosPorMesQuery,
  useGetTodosCobrosPorMesQuery,
  useGetInformacionRecuentoTareasQuery,
  useGetCobrosTotalesPendientesPorMesQuery,
  useGetRecaudacionesMensualesSucursalesQuery,
  useGetRecaudacionesMensualesGavQuery,
  useGetInformeLiquidacionQuery,
  useGetInformacionFacturacionAnioQuery,
  useGetInformacionEstadisticasFacturacionQuery,
  useGetInformacionCrecimientoClientesQuery,
  useObtenerRecaudacionesYFacturasTotalesQuery,
  useGetKpiEficienciaCobranzaQuery,
  useGetKpiCumplimientoTareasQuery,
  useGetKpiMorosidadQuery,
  useGetInformacionfacturacionPorSucursalesQuery,
  useGetDetalleFacturasMensualesQuery,
  useGetDetalleComisionesTareaQuery,
  useGetDetalleFacturasTareaQuery,
  useGetDetalleFacturasTareasGeneralQuery,
  useGetDetalleRecaudacionFacturasQuery,
  useLazyGetDetalleRecaudacionFacturasQuery,
  useLazyGetDetalleFacturasTareasGeneralQuery,
  useLazyGetDetalleComisionesTareaQuery,
  useLazyGetDetalleFacturasTareaQuery,
  useLazyGetDetalleFacturasMensualesQuery,
  useLazyGetInformacionRecuentoTareasQuery,
  useLazyGetInformacionfacturacionPorSucursalesQuery,
  useLazyGetCobrosPorMesQuery,
  useLazyGetInformacionFacturacionAnioQuery,
  useLazyGetInformacionEstadisticasFacturacionQuery,
  useLazyGetCobrosPendientesPorMesQuery,
  useGetCobrosPendientesPorMesQuery,
  useLazyObtenerRecaudacionesYFacturasTotalesQuery,
  useLazyGetTodosCobrosPorMesQuery,
  useLazyGetInformacionCrecimientoClientesQuery,
  useLazyGetPagosPromedioClientesQuery,
  useLazyGetFacturasPorDiaQuery,
  useLazyGetNLeadsQuery,
  useLazyGetTasaRetencionClientesQuery,
  useLazyGetTasaClientesPerdidosQuery,
  useLazyGetTasaCrecimientoClienteQuery,
  useLazyGetCapacidadPorCarteraQuery,
  useLazyGetTasaNegociacionConcretaQuery,
  useLazyGetCobrosTotalesPendientesPorMesQuery,
  useLazyGetRecaudacionesMensualesSucursalesQuery,
  useLazyGetRecaudacionesMensualesGavQuery,
  useLazyGetInformeLiquidacionQuery,
  useGetInformacionfacturacionPorSucursalesConFechaQuery,
  useLazyGetInformacionfacturacionPorSucursalesConFechaQuery,
} = informesApi;
